import {
  Container,
  Typography,
  Paper,
  Grid,
  Button,
  Box,
  FormHelperText,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { RolesContext } from "../context/User";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import "../App.css";
import CustomCard from "../styleComp/CustomCard";
import ErrorIcon from "@mui/icons-material/Error";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import { useNavigate } from "react-router-dom";

export default function AboutInfoPage() {
  const { validationPage } = useErrValidate();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    mail: "",
    phone: "",
    company: "",
    companyName: "",
    text: "",
    person: "",
  });
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [messagerror, setMessagerror] = useState(false);

  useEffect(() => {
    validationPage("general");
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = "שם הוא שדה חובה";
    }
    if (!formData.phone) {
      newErrors.phone = "טלפון הוא שדה חובה";
    }
    if (!formData.text) {
      newErrors.text = "תוכן הוא שדה חובה";
    }
    if (!formData.person) {
      newErrors.person = "מחלקה הוא שדה חובה";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      try {
        const response = await axios.post(`/mail/sendEmail`, {
          formData,
        });
        setFormData({
          name: "",
          mail: "",
          phone: "",
          company: "",
          companyName: "",
          text: "",
        });
        setErrors({});
        setFormSubmitted(true);
        setTimeout(() => setFormSubmitted(false), 9000);
      } catch {
        setMessagerror(true);
        setTimeout(() => setMessagerror(false), 9000);
      }
    }
  };
  return (
    // <div className="page-container">
    <CustomCard>
      <Container width="100%">
        <Box
          sx={{
            maxHeight: "70vh",
            overflowY: "auto",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div>
            <Typography variant="h4" gutterBottom align="center">
              יצירת קשר
            </Typography>
            <div style={{ height: "12px" }} />
            <Typography variant="h5" gutterBottom align="center">
              <strong> מוקד קשרי הלקוחות</strong>
            </Typography>
            <Typography variant="h5" gutterBottom align="center">
              שעות פעילות המוקד
            </Typography>
            <Typography variant="h5" gutterBottom align="center">
              ימים א'-ה' בין השעות 08:00-17:00
            </Typography>
            <Typography variant="h5" gutterBottom align="center" />
            <Typography variant="body1" gutterBottom align="center">
              מומחי החברה עומדים לרשותך באמצעות מוקד קשרי הלקוחות בכל פנייה.
            </Typography>
            <Typography variant="body1" gutterBottom align="center">
              מלאו את הטופס ונציגנו ישוב אליכם בהקדם:
            </Typography>
          </div>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={1} >
              <Grid item xs={12} md={6}>
                <TextField
                  label="שם *"
                  name="name"
                  value={formData.name}
                  size="small"
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                  margin="normal"
                  // required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  label="טלפון *"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  margin="normal"
                  // required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  label="אימייל"
                  name="mail"
                  value={formData.mail}
                  onChange={handleChange}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  label='ח"פ'
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  size="small"
                  label="שם חברה"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl sx={{ width: "100%" ,marginTop: "3%"}}>
                  <InputLabel id="person-label">מחלקה *</InputLabel>
                  <Select
                    size="small"
                    name="person"
                    labelId="person-label"
                    error={!!errors.person}
                    helperText={errors.person}
                    value={formData.person}
                    label={"מחלקה *"}
                    onChange={handleChange}
                    margin="normal"
                    fullWidth
                  >
                    <MenuItem value="מחלקת גבייה"> מחלקת גבייה</MenuItem>
                    <MenuItem value="שירות לקוחות">שירות לקוחות</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  size="small"
                  label="תוכן *"
                  name="text"
                  value={formData.text}
                  onChange={handleChange}
                  error={!!errors.text}
                  helperText={errors.text}
                  multiline
                  rows={4}
                  margin="normal"
                  // required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                {formSubmitted ? (
                  <Alert
                    icon={<CheckIcon fontSize="inherit" />}
                    severity="success"
                  >
                    הטופס נשלח בהצלחה{" "}
                  </Alert>
                ) : (
                  <Button type="submit" variant="contained" color="primary">
                    שלח
                  </Button>
                )}
                {messagerror ? (
                  <Alert severity="warning">
                    התקבלה שגיאה בשליחת הטופס. נא לנסות שוב בעוד מספר דקות
                  </Alert>
                ) : null}
              </Grid>
            </Grid>
          </form>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          position="absolute"
          bottom={20}
          left={0}
          right={0}
        >
          <Typography
            variant="caption"
            sx={{ marginTop: "1.5rem", color: "grey" }}
          >
            במקרה של תקלה ניתן לדיווח כאן
            <Button
              href="https://forms.monday.com/forms/722aaa5f45f5718cb179ffb62f4299dd?r=use1"
              target="_blank"
              variant="text"
              endIcon={<ErrorIcon />}
              style={{ textDecoration: "underline", fontSize: "12px" }}
            >
              דיווח תקלה
            </Button>
          </Typography>
        </Box>
      </Container>
    </CustomCard>
    // </div>
  );
}
